class VideoLoader {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.isPlaying = false;
        this.isLoop = this.wrapper.dataset.isLoop;

        this.playButton = this.wrapper.querySelector('.js-video-loader-play-button');
        this.teaser = this.wrapper.querySelector('.js-video-loader-teaser');
        this.loader = this.wrapper.querySelector('.js-video-loader');
        this.video = this.wrapper.querySelector('.js-video');

        if (!this.playButton) return;

        this.playButton.addEventListener('click', () => {
            if (!this.isPlaying) {
                if (!this.wrapper.dataset.embedUrl) {
                    this.createVideo();
                } else {
                    this.createIframe();
                }
            }
        });
    }

    createVideo() {
        this.loader.style.display = 'block';

        this.video.src = this.wrapper.dataset.videoSrc;
        this.video.controls = this.wrapper.dataset.showControls;

        this.hideTeaser();

        this.video.addEventListener('ended', () => {
            this.showTeaser();
        });
    }

    createIframe() {
        this.wrapper.style.backgroundImage = 'none';

        this.iframe = document.createElement('iframe');
        this.wrapper.appendChild(this.iframe);
        this.iframe.classList.add('video-loader__iframe');

        const {embedUrl} = this.wrapper.dataset;
        this.iframe.src = embedUrl;

        this.hideTeaser();
    }

    hideTeaser() {
        this.teaser.style.display = 'none';

        if (this.isLoop) {
            this.video.loop = true;
        }

        this.video.play();
    }

    showTeaser() {
        this.teaser.style.display = 'flex';
        this.loader.style.display = 'none';
    }
}

const videoLoader = {
    init() {
        this.videoWrapper = document.querySelectorAll('.js-video-loader-wrapper');

        if (!this.videoWrapper) return;

        this.videoWrapper.forEach((element) => {
            this.videoLoader = new VideoLoader(element);
        });
    },
};

export default videoLoader;
